import { Query, QueryFilter, QueryFilterValue } from "../query";

/** PostgREST GET URLs fail at proxies when `in.(…)` lists too many ids (414 URI Too Long). */
export const SUPABASE_IN_FILTER_BATCH_SIZE = 50;

export type OversizedInFilter = { field: string; values: unknown[] };

export function getEffectiveFilter(query: Query<any, any>): QueryFilter<any> {
  return {
    ...query.filter,
    ...query.joinsFilter,
  };
}

export function findOversizedInFilter(
  filter: QueryFilter<any>,
  batchSize = SUPABASE_IN_FILTER_BATCH_SIZE,
): OversizedInFilter | null {
  for (const [field, condition] of Object.entries(filter)) {
    if (!condition || condition.op !== "in" || !("value" in condition) || !Array.isArray(condition.value)) {
      continue;
    }
    if (condition.value.length > batchSize) {
      return { field, values: condition.value };
    }
  }
  return null;
}

export function chunkValues<T>(values: T[], batchSize = SUPABASE_IN_FILTER_BATCH_SIZE): T[][] {
  const batches: T[][] = [];
  for (let i = 0; i < values.length; i += batchSize) {
    batches.push(values.slice(i, i + batchSize));
  }
  return batches;
}

export function withInFilterValues(
  query: Query<any, any>,
  field: string,
  values: unknown[],
): Query<any, any> {
  return query.in(field as any, values as any);
}

export function isInFilterValue(condition: QueryFilterValue<any> | undefined): condition is {
  op: "in";
  value: unknown[];
} {
  return Boolean(
    condition && condition.op === "in" && "value" in condition && Array.isArray(condition.value),
  );
}
